<template>
    <div class="guide" :style="pagecontainer" v-if="show" @click.stop="close">
        <div class="popup" >
            <img class="img" :src="guideUrl" mode=""></img>
            <img src="" alt="">
        </div>
    </div>
</template>
<script>
import { qywx} from "@/utils/guidance";
export default {
    data(){
        return{
            show:false,
            pagecontainer: {
            maxWidth: "750px",
            margin: "0 auto",
            },
        }
    },
    computed: {
			guideUrl() {
				let src = require("../../assets/image/community/guide_1.png")
				if (qywx) {
					src = require("../../assets/image/community/guide_2.png")
				}
				return src
			}
		},
        methods:{
            close(){
                this.show= false
            }
        }
}
</script>
<style scoped lang="scss">
 .guide{
    position: fixed;
    z-index: 99999;
    top: 0;
    background-color: rgba(0, 0, 0, 0.7);
    width: 100%;
    height: calc(var(--vh, 1vh) * 100);
    .popup{
		display: flex;
		.img {
			margin-top: .266667rem /* 20/75 */;
			margin-right: .666667rem /* 50/75 */;
			margin-left: auto;
			width: 5.586667rem /* 419/75 */;
			height: 5.2rem /* 390/75 */;
		}
	}
 }
</style>